import React from 'react';
import { Link } from 'react-router-dom';
import { Palette, ArrowRight } from 'lucide-react';
import AnimatedSection from '../components/AnimatedSection';
import SEO from '../components/SEO';
import { useI18n } from '../i18n/I18nContext';

function BrandDesignPage() {
  const { t, localizedPath } = useI18n();
  const tr = t.servicePages.brandDesign;

  return (
    <div className="container mx-auto px-4 py-20">
      <SEO title={tr.title} description={tr.metaDescription} canonicalPath={localizedPath('/services/brand-design')} />
      <div className="max-w-4xl mx-auto">
        <AnimatedSection animation="fade-in-up">
          <div className="flex items-center gap-4 mb-8">
            <Palette className="h-12 w-12 text-[#FF5500]" />
            <h1 className="text-4xl font-bold">{tr.title}</h1>
          </div>
        </AnimatedSection>
        <AnimatedSection animation="fade-in-up" delay={100}>
          <p className="text-xl text-gray-300 mb-8">
            {tr.intro}
          </p>
        </AnimatedSection>
        <AnimatedSection animation="fade-in-up" delay={200} className="stagger-grid grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-zinc-900 p-8 rounded-lg border border-zinc-800">
            <h3 className="text-xl font-bold mb-4">{tr.designServices}</h3>
            <ul className="space-y-3 text-gray-300">
              {tr.designItems.map((item, i) => <li key={i}>• {item}</li>)}
            </ul>
          </div>
          <div className="bg-zinc-900 p-8 rounded-lg border border-zinc-800">
            <h3 className="text-xl font-bold mb-4">{tr.deliverables}</h3>
            <ul className="space-y-3 text-gray-300">
              {tr.deliverablesItems.map((item, i) => <li key={i}>• {item}</li>)}
            </ul>
          </div>
        </AnimatedSection>
        <AnimatedSection animation="scale-in" delay={300}>
          <div className="bg-gradient-to-r from-[#FDCB12] to-[#FF5500] p-8 rounded-lg text-black">
            <h3 className="text-2xl font-bold mb-4">{tr.ctaTitle}</h3>
            <p className="mb-6">{tr.ctaText}</p>
            <Link to={localizedPath('/#contact')} className="button-shine inline-flex items-center bg-black text-white px-6 py-3 rounded-md hover:bg-zinc-800 transition-colors">
              {tr.ctaButton}
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </div>
        </AnimatedSection>
      </div>
    </div>
  );
}

export default BrandDesignPage;
